module.exports = __webpack_public_path__ + "img/btgb2021_loading_00.34e7da98.png";